import React from 'react';
import {
	formatDateWithDayOfTheWeek,
	formatDate,
	formatTime
} from '../utils/util';
import { GQLTestType } from '../generated/graphql';
import { testTypeConverter } from '../utils/enum-converter';
import { OLD_TEST_TYPE, OLD_TEST_COURSE_LABEL, OLD_TEST_TYPE_LABEL, KYOFUKU_MEMBER_TYPE_LABEL, CHUEI_BANK_MEMBER_TYPE_LABEL, SEX_LABEL, HOW_DID_YOU_KNOW_LABEL } from '../entry-points/entry';
import { typeLabel } from '../../../api/src/enms/type';

export function Confirm({
	onNext,
	onPrev,
	testLocation,
	testDate,
	lastTestLocation,
	testTypeState: [testType],
	testCourseState: [testCourse],
	kyofukuMemberTypeState: [kyofukuMemberType],
	kyofukuMemberIdState: [kyofukuMemberId],
	kyofukuMemberNameState: [],
	chueiBankMemberTypeState: [chueiBankMemberType],
	mbClubPaymentMethodState: [],
	mbClubMemberIdState: [mbClubMemberId],
	lastTestLocationState: [],
	lastTestDateState: [lastTestDate],
	zipcodeState: [zipcode],
	address1State: [address1],
	address2State: [address2],
	phoneNumberState: [phoneNumber],
	mailAddressState: [mailAddress],
	firstNameState: [firstName],
	firstNameKanaState: [firstNameKana],
	lastNameState: [lastName],
	lastNameKanaState: [lastNameKana],
	sexState: [sex],
	birthdayState: [birthday],
	messageState: [],
	antiCovid19TestState: [antiCovid19Test],
	hasEntryBeforeState: [hasEntryBefore],
	groupCodeState: [groupCode],
	serviceCodeState: [serviceCode],
	howDidYouKnowState: [howDidYouKnow],
	howDidYouKnowAdMediaState: [howDidYouKnowAdMedia],
	introducerIdState: [introducerId],
	typeState: [type]
}: any) {
	if (!testDate || !testLocation) {
		return <></>;
	}
	return <>
		<h3>申し込み内容の確認</h3>
		<dl>
			<dt>コース</dt>
			<dd>
				{testType === OLD_TEST_TYPE.OTHER ? OLD_TEST_COURSE_LABEL[testCourse] : OLD_TEST_TYPE_LABEL[testType]}
			</dd>
		</dl>
		<dl>
			<dt>検査項目</dt>
			<dd>{typeLabel[type]}</dd>
		</dl>
		{testLocation && testLocation.acceptAntiCovid19Test && <>
			<dl>
				<dt>新型コロナウィルス抗体検査</dt>
				<dd>{antiCovid19Test ? '希望する' : '希望しない'}</dd>
			</dl>
		</>}
		{testLocation && testType !== OLD_TEST_TYPE.KYOFUKU && <>
			<dl>
				<dt>検査会場</dt>
				<dd>{testLocation.name}</dd>
			</dl>
		</>}
		{testDate && <>
			<dl>
				<dt>検査日</dt>
				<dd>{formatDateWithDayOfTheWeek(testDate.startDate)}</dd>
			</dl>
			<dl>
				<dt>検査時間</dt>
				<dd>{formatTime(testDate.startDate)} - {formatTime(testDate.endDate)}</dd>
			</dl>
		</>}
		{testType === OLD_TEST_TYPE.MB_CLUB && <>
			{mbClubMemberId && <>
				<dl>
					<dt>MBクラブID</dt>
					<dd>{mbClubMemberId}</dd>
				</dl>
			</>}
			<dl>
				<dt>前回検査会場</dt>
				<dd>{lastTestLocation && lastTestLocation.name}</dd>
			</dl>
			<dl>
				<dt>前回検査日</dt>
				<dd>{formatDateWithDayOfTheWeek(lastTestDate)}</dd>
			</dl>
		</>}
		<dl>
			<dt>支払い</dt>
			<dd>{testTypeConverter(testType, testCourse) === GQLTestType.StandardFreeLp ? '現地決済' : 'コンビニ払い'}</dd>
		</dl>
		{testType === OLD_TEST_TYPE.KYOFUKU && <>
			<dl>
				<dt>神奈川県教育福祉振興会会員タイプ</dt>
				<dd>
					{KYOFUKU_MEMBER_TYPE_LABEL[kyofukuMemberType]}
				</dd>
			</dl>
			<dl>
				<dt>神奈川県教育福祉振興会会員ID</dt>
				<dd>{kyofukuMemberId}</dd>
			</dl>
		</>}
		{testType === OLD_TEST_TYPE.CHUEI_BANK && <>
			<dl>
				<dt>中栄信用金庫 会員タイプ</dt>
				<dd>{CHUEI_BANK_MEMBER_TYPE_LABEL[chueiBankMemberType]}</dd>
			</dl>
		</>}
		<dl>
			<dt>郵便番号</dt>
			<dd>{zipcode}</dd>
		</dl>
		<dl>
			<dt>住所1</dt>
			<dd>{address1}</dd>
		</dl>
		<dl>
			<dt>住所2</dt>
			<dd>{address2}</dd>
		</dl>
		<dl>
			<dt>電話番号</dt>
			<dd>{phoneNumber}</dd>
		</dl>
		<dl>
			<dt>メールアドレス</dt>
			<dd>{mailAddress}</dd>
		</dl>
		<dl>
			<dt>氏名</dt>
			<dd>{lastName} {firstName}</dd>
		</dl>
		<dl>
			<dt>氏名(フリガナ)</dt>
			<dd>{lastNameKana} {firstNameKana}</dd>
		</dl>
		<dl>
			<dt>性別</dt>
			<dd>{SEX_LABEL[sex]}</dd>
		</dl>
		<dl>
			<dt>生年月日</dt>
			<dd>{formatDate(birthday)}</dd>
		</dl>
		<dl>
			<dt>以前にMetallo-balance検査を受けたことがある</dt>
			<dd>{hasEntryBefore ? 'はい' : 'いいえ'}</dd>
		</dl>
		{groupCode &&
			<dl>
				<dt>グループコード</dt>
				<dd>{groupCode}</dd>
			</dl>}
		{serviceCode &&
			<dl>
				<dt>サービスコード</dt>
				<dd>{serviceCode}</dd>
			</dl>}
		{introducerId &&
			<dl>
				<dt>法人ID</dt>
				<dd>{introducerId}</dd>
			</dl>}
		{hasEntryBefore || <>
			<dl>
				<dt>どこでメタロ・バランスを知りましたか</dt>
				<dd>{HOW_DID_YOU_KNOW_LABEL[howDidYouKnow]}</dd>
			</dl>
			{howDidYouKnowAdMedia && <dl>
				<dt>雑誌・新聞・広告などの名称</dt>
				<dd>{howDidYouKnowAdMedia}</dd>
			</dl>}
		</>}
		<div className="button-container">
			<button className="prev-button" onClick={() => {onPrev();}}>戻る</button>
			<div className="spacer"></div>
			<button className="next-button" onClick={() => {onNext();}}>送信</button>
		</div>
	</>;
}
